import { createSaveAction } from '@paysera/redux-state-restore';
import storageConfig from '%paysera_seat_selection/js/seatSelection/redux/component/orm/config/storage';

export default createSaveAction(storageConfig);
